(() => {
  "use strict";

  const path = window.location.pathname.replace(/\/$/, "");
  const isEmbedded = new URLSearchParams(window.location.search).has(
    "embedded"
  );

  const isLegacyPaymentPath =
    path.endsWith("/pages/revisa-y-paga") ||
    path.endsWith("/pages/arma-tus-stickers-pago");

  if (isLegacyPaymentPath && !isEmbedded) {
    const target = new URL(
      "/pages/arma-tus-stickers-resumen",
      window.location.origin
    );
    target.searchParams.set("open-payment", "1");

    const mode = new URLSearchParams(window.location.search).get("mode");
    if (mode) {
      target.searchParams.set("mode", mode);
    }

    window.location.replace(target.href);
  }
})();
